import React, { Component } from "react";
import { TextField } from "material-ui";
import { DatePickerCalendar } from "./DatePickerCalendar";
import {
  dateStringAustraliatoDate,
  dateToDateStringAustralia
} from "./DatePickerHelper";
import { CheckMarkIcon } from "../CheckMark";

const styles = {
  containerStyle: {
    position: "relative",
    width: "100%",
    display: "inline-block"
  },
  style: {
    width: "100%"
  },
  errorStyle: {},
  inputStyle: {
    color: "#555"
  },
  floatingLabelStyle: {
    color: "#ccc"
  },
  underlineStyle: {},
  underlineFocusStyle: {
    borderColor: "transparent"
  },
  errorIconStyle: {
    fontSize: "12px",
    verticalAlign: "bottom",
    fontWeight: "700"
  },
  validIconStyle: {
    fontSize: "24px",
    position: "absolute",
    right: "0",
    top: "50%",
    marginTop: "0",
    color: "#009600"
  }
};

class CustomDatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
      value: ""
    };
    this.mouseInside = false;
  }

  componentWillMount = () => {
    document.addEventListener("click", this.handleDocumentClick);
  };

  componentDidMount = () => {
    if (this.props.value != null && this.props.value !== "") {
      this.setState({
        value: this.props.value
      });
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener("click", this.handleDocumentClick);
  };

  renderTick = isValid => {
    if (isValid) {
      return (
        <i style={styles.validIconStyle}>
          <CheckMarkIcon />
        </i>
      );
    }
    return null;
  };

  handleDocumentClick = () => {
    if (this.state.isShow && !this.mouseInside) {
      this.setState({
        isShow: this.clickedInside
      });
    }
  };

  handleFocus = () => {
    if (!this.state.isShow) {
      this.setState({
        isShow: true
      });
    }
  };

  handleMouseEnter = () => {
    this.mouseInside = true;
  };

  handleMouseLeave = () => {
    this.mouseInside = false;
  };

  handleChange = e => {
    const value = e.target.value;
    const reg = /^[0-9/]+$/;
    if (!reg.test(value) && value !== "") {
      return;
    }

    this.setState({
      value: value
    });
    this.props.onDateChange(value);
  };

  handleSelectedDay = date => {
    const value = dateToDateStringAustralia(date);
    this.setState({
      value: value
    });
    this.props.onDateChange(value);
  };

  handleHideAfterDayClick = () => {
    if (this.state.isShow) {
      this.setState({
        isShow: false
      });
    }
  };

  render() {
    const errorText =
      this.props.errorText !== undefined && this.props.errorText !== "" ? (
        <span>
          <i className="material-icons" style={styles.errorIconStyle}>
            close
          </i>
          {" " + this.props.errorText}
        </span>
      ) : (
        this.props.errorText
      );
    //floating label fixed when calendar is showing
    const floatingLabelFixed = this.state.isShow;
    const calendarValue = dateStringAustraliatoDate(this.state.value);
    return (
      <span
        style={styles.containerStyle}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <TextField
          floatingLabelText={this.props.floatingLabelText}
          errorText={errorText}
          style={styles.style}
          floatingLabelFixed={floatingLabelFixed}
          floatingLabelStyle={styles.floatingLabelStyle}
          inputStyle={styles.inputStyle}
          errorStyle={styles.errorStyle}
          underlineStyle={styles.underlineStyle}
          underlineFocusStyle={styles.underlineFocusStyle}
          onKeyPress={this.handleKeyPress}
          onChange={this.handleChange}
          onFocus={this.handleFocus}
          value={this.state.value}
          ref={input => {
            this.input = input;
          }}
        />
        {this.state.isShow ? (
          <DatePickerCalendar
            value={calendarValue}
            onSeletedDay={this.handleSelectedDay}
            hideAfterDayClick={this.handleHideAfterDayClick}
          />
        ) : null}
        {this.renderTick(this.props.isValid)}
      </span>
    );
  }
}

export { CustomDatePicker };



// WEBPACK FOOTER //
// ./src/modules/ContactForm/components/DatePicker/index.js